module.exports = __webpack_public_path__ + "img/success.da79c900.svg";